<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> {{project.name}}</h3>

      <div class="box-tools">
        <el-button class="pull-right" size="mini" @click="goBack()" plain><i class="fa fa-reply"></i> 返回</el-button>
      </div>
    </div>
    <div class="box-body">
      <el-table class="list-table" :data="paperList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="试卷标题"></el-table-column>
        <el-table-column prop="subtitle" label="标签"></el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="lookPersonReport(scope.row)" size="small"><i class="fa fa-eye"></i> 查看详情</el-button>
            <el-dropdown placement="bottom-start" style="margin-left:10px;">
              <el-button type="text" size="small" @click="downLoadAnswerQR(scope.row)"><i class="fa fa-qrcode"></i> 下载二维码</el-button>
              <el-dropdown-menu slot="dropdown" class="personal_dropdown">
                <el-dropdown-item>
                  <img :src="'/api/project/qrcode/standard/' + projectId" alt="">
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <person-list :visible="drawerVisible" :project-id="projectId" :paper="curPaper" @done="closePerson"></person-list>
  </div>

</template>

<script>
  import {getPersonScheme} from "@api/manage/company";
  import {get} from "@api/evaluation/project";
  import PersonList from "./PersonList.vue";

  export default {
    name: 'project-person',
    data() {
      return {
        project : {},
        curPaper:null,
        paperList:[],
        drawerVisible:false,
        paper:{}
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      projectId(){
        return this.$route.params.projectId
      }
    },
    components: {
      PersonList
    },
    methods: {
      fetchData(){
        get(this.projectId).then(res=>{
          this.project = res.data.result
        })

        getPersonScheme(this.projectId).then(res => {
          if (res.data.code === 200) {
            this.paperList = res.data.result || []
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      downLoadAnswerQR (val) {
        let atag = document.createElement('a')
        atag.className = 'downLoadAnswer'
        atag.href = `/api/project/qrcode/standard/${this.projectId}`
        atag.setAttribute('target', '_blank')
        atag.setAttribute('download', this.project.name + '.jpg')
        document.querySelector('body').appendChild(atag)
        atag.click()
        document.querySelector('.downLoadAnswer').remove()
      },
      lookPersonReport(val){
        console.info(val)
        this.drawerVisible =true
        this.curPaper = val
      },
      closePerson(){
        this.drawerVisible =false
        this.curPaper = null
      },
      goBack: function () {
        this.$router.go(-1);
      },
    }
  }
</script>

